import { StyleSheet, View } from 'react-native';
import { CurrentIssueContextProvider } from '../../issues/issueContext';
import { ActivityFilters } from './activityFilters';
import { ActivitiesProps, ActivityList } from './activityList';

/**
 * Thin layout wrapper around `ActivityList`. `campaignRows` (PR 4 / B3)
 * flows through untouched — the merge + polymorphic render lives in
 * `ActivityList`.
 */
export const ActivityFoldOneColumn = (props: ActivitiesProps) => {
  return (
    <CurrentIssueContextProvider>
      {
        !props.hideFilterBar && (
          <View style={styles.filtersContainer}>
            <ActivityFilters assetId={props.assetId} />
          </View>
        )
      }
      <View style={styles.listContainer}>
        <ActivityList
          onDataLoaded={props.onDataLoaded}
          {...props}
        />
      </View>
    </CurrentIssueContextProvider>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  filtersContainer: {
    paddingHorizontal: 16,
    paddingBottom: 16,
  },
  listContainer: {
    flex: 1,
    width: '100%',
    overflow: 'hidden',
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    paddingBottom: 8,
  },
  gutter: {
    width: 24,
  },
});
